// GENERATED by scripts/gen-currency-patterns.mjs. Do not edit by hand; see
// src/lib/display-currency-format.ts for why prices are formatted from this.
// Taken from Node v22.20.0 (ICU 77.1, CLDR 47.0).

import type { CurrencyPattern } from './display-currency-format';

export const CURRENCY_PATTERNS: Record<string, CurrencyPattern> = {
  USD: {
    locale: 'en-US',
    prefix: '$', suffix: '',
    negativePrefix: '-$', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  EUR: {
    locale: 'de-DE',
    prefix: '', suffix: '\u00a0€',
    negativePrefix: '-', negativeSuffix: '\u00a0€',
    decimal: ',', group: '.',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  GBP: {
    locale: 'en-GB',
    prefix: '£', suffix: '',
    negativePrefix: '-£', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  JPY: {
    locale: 'ja-JP',
    prefix: '￥', suffix: '',
    negativePrefix: '-￥', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 0,
  },
  AUD: {
    locale: 'en-AU',
    prefix: '$', suffix: '',
    negativePrefix: '-$', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  CAD: {
    locale: 'en-CA',
    prefix: '$', suffix: '',
    negativePrefix: '-$', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  CHF: {
    locale: 'de-CH',
    prefix: 'CHF\u00a0', suffix: '',
    negativePrefix: 'CHF-', negativeSuffix: '',
    decimal: '.', group: '\u2019',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  CNY: {
    locale: 'zh-CN',
    prefix: '¥', suffix: '',
    negativePrefix: '-¥', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  INR: {
    locale: 'en-IN',
    prefix: '₹', suffix: '',
    negativePrefix: '-₹', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 2,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  BRL: {
    locale: 'pt-BR',
    prefix: 'R$\u00a0', suffix: '',
    negativePrefix: '-R$\u00a0', negativeSuffix: '',
    decimal: ',', group: '.',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  ZAR: {
    locale: 'en-ZA',
    prefix: 'R\u00a0', suffix: '',
    negativePrefix: '-R\u00a0', negativeSuffix: '',
    decimal: ',', group: '\u00a0',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  SGD: {
    locale: 'en-SG',
    prefix: '$', suffix: '',
    negativePrefix: '-$', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  HKD: {
    locale: 'zh-HK',
    prefix: 'HK$', suffix: '',
    negativePrefix: '-HK$', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  NZD: {
    locale: 'en-NZ',
    prefix: '$', suffix: '',
    negativePrefix: '-$', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  SEK: {
    locale: 'sv-SE',
    prefix: '', suffix: '\u00a0kr',
    negativePrefix: '\u2212', negativeSuffix: '\u00a0kr',
    decimal: ',', group: '\u00a0',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  NOK: {
    locale: 'nb-NO',
    prefix: '', suffix: '\u00a0kr',
    negativePrefix: '\u2212', negativeSuffix: '\u00a0kr',
    decimal: ',', group: '\u00a0',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  DKK: {
    locale: 'da-DK',
    prefix: '', suffix: '\u00a0kr.',
    negativePrefix: '-', negativeSuffix: '\u00a0kr.',
    decimal: ',', group: '.',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  MXN: {
    locale: 'es-MX',
    prefix: '$', suffix: '',
    negativePrefix: '-$', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  TRY: {
    locale: 'tr-TR',
    prefix: '₺', suffix: '',
    negativePrefix: '-₺', negativeSuffix: '',
    decimal: ',', group: '.',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  RUB: {
    locale: 'ru-RU',
    prefix: '', suffix: '\u00a0₽',
    negativePrefix: '-', negativeSuffix: '\u00a0₽',
    decimal: ',', group: '\u00a0',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  PLN: {
    locale: 'pl-PL',
    prefix: '', suffix: '\u00a0zł',
    negativePrefix: '-', negativeSuffix: '\u00a0zł',
    decimal: ',', group: '\u00a0',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 2, fractionDigits: 2,
  },
  MYR: {
    locale: 'ms-MY',
    prefix: 'RM\u00a0', suffix: '',
    negativePrefix: '-RM\u00a0', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  THB: {
    locale: 'th-TH',
    prefix: '฿', suffix: '',
    negativePrefix: '-฿', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  IDR: {
    locale: 'id-ID',
    prefix: 'Rp\u00a0', suffix: '',
    negativePrefix: '-Rp\u00a0', negativeSuffix: '',
    decimal: ',', group: '.',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  CZK: {
    locale: 'cs-CZ',
    prefix: '', suffix: '\u00a0Kč',
    negativePrefix: '-', negativeSuffix: '\u00a0Kč',
    decimal: ',', group: '\u00a0',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  HUF: {
    locale: 'hu-HU',
    prefix: '', suffix: '\u00a0Ft',
    negativePrefix: '-', negativeSuffix: '\u00a0Ft',
    decimal: ',', group: '\u00a0',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 2, fractionDigits: 2,
  },
  PHP: {
    locale: 'fil-PH',
    prefix: '₱', suffix: '',
    negativePrefix: '-₱', negativeSuffix: '',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  RON: {
    locale: 'ro-RO',
    prefix: '', suffix: '\u00a0RON',
    negativePrefix: '-', negativeSuffix: '\u00a0RON',
    decimal: ',', group: '.',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  ILS: {
    locale: 'he-IL',
    prefix: '\u200f', suffix: '\u00a0\u200f₪',
    negativePrefix: '\u200f\u200e-', negativeSuffix: '\u00a0\u200f₪',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
  AED: {
    locale: 'ar-AE',
    prefix: '\u200f', suffix: '\u00a0د.إ.\u200f',
    negativePrefix: '\u200f\u200e-', negativeSuffix: '\u00a0د.إ.\u200f',
    decimal: '.', group: ',',
    primaryGrouping: 3, secondaryGrouping: 3,
    minimumGroupingDigits: 1, fractionDigits: 2,
  },
};
